<template>
  <div class="public-info-grid-item" :class="{roundedStyle}">
    <div v-if="listId" class="public-info-grid-item-badge">
      {{ listId }}
    </div>
    <vz-icon
      v-else
      :url="item.icon.url"
      :name="item.icon.name"
      :size="getIconSize(item)"
      variant="primary"
      no-masked-icon
    />
    <div class="public-info-grid-item-data">
      <div v-if="item.title" class="public-info-grid-item-title">{{ item.title }}</div>
      <slot>
        <span v-if="item.text" v-html="item.text" />
        <nuxt-link
          v-if="item.link"
          :to="item.link.to"
          class="text-decoration-underline"
          :class="{'display-block mt-5': !item.textAfter}"
        >
          {{ item.link.title }}
        </nuxt-link>
        <span v-if="item.textAfter" v-html="item.textAfter" />
        <public-text-warning v-if="item.warning">
          {{ item.warning }}
        </public-text-warning>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { PublicInfoGridItem } from '~/types/public'
import PublicTextWarning from '~~/components/public/public-text-warning.vue'
import $breakpoints from '~~/composables/breakpoints'

const props = defineProps({
  item: {
    type: Object as PropType<PublicInfoGridItem>,
    default: () => []
  },
  roundedStyle: {
    type: Boolean,
    default: false
  },
  listId: {
    type: Number,
    default: null
  }
})

function getIconSize(item: PublicInfoGridItem): string | number {
  if (props.roundedStyle) {
    return $breakpoints.width > 1087 ? (item.icon?.size || 32) : 26
  }
  return $breakpoints.width > 1087 ? (item.icon?.size || 56) : 36
}
</script>

<style lang="scss" scoped>
.public-info-grid-item-badge {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 30px;
  height: 30px;
  font-size: 20px;
  font-weight: 900;
  transform: translateY(-5px);
  background-color: $primary;
  color: $white;
  border-radius: 50%;
}
</style>
